export default __webpack_public_path__ + "static/media/Inter-ExtraBoldItalic.c437ff9c.woff2";